import Header from "./Header";
import { Outlet } from "react-router-dom";
import Footer from "./footer";
//import Footer from "./footer";

const DefaultLayouts = () => {
    return (
        <>        
            <Header />           
                <Outlet />
            <Footer />
        </>
    );
}
export default DefaultLayouts;